import { ThingStatusAccess } from './thingStatusAccess';
import { ThingControlAccess } from './thingControlAccess';
export class ThingUserAccess {
    groupName: string;
    userList: Array<string>;
    statusAccess: Array<string>;
    controlAccess: Array<string>;

    constructor(gropuName: string, userList: Array<string>, statusAccess: Array<string>, controlAccess: Array<string>) {
        this.groupName = gropuName;
        this.userList = userList;
        this.statusAccess = statusAccess;
        this.controlAccess = controlAccess;
    }
}